var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.bindsSrc)?_c('binds-svg-loader',{staticClass:"binds-icon binds-icon-image",class:[_vm.$bindsActiveTheme],attrs:{"binds-src":_vm.bindsSrc},on:{"binds-loaded":function($event){return _vm.$emit('binds-loaded')}}}):_c('i',{staticClass:"binds-icon binds-icon-font",class:[_vm.$bindsActiveTheme]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }